import styled from "styled-components";
import { TypographyV2 } from "config/font";
import { ColorV2 } from "config/colors";

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TimeRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
`;

export const TimeSeparator = styled.span`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue4};
  margin-bottom: 8px;
`;

export const BreakRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
`;

export const BreakSuffix = styled.span`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue4};
  margin-bottom: 8px;
`;
